<template>
    <v-dialog
      v-model="dialog"
      width="350"
    >
      <template v-slot:activator="{ on, attrs }">
          <v-text-field
              clearable
              append-icon="event"
              label="Filter Date & Time"
              single-line
              style="max-width: 300px"
              class="mr-3"
              v-bind="attrs"
              v-on="on"
              readonly
              v-model="SelectedDateTime"
              dense>
          </v-text-field>
      </template>

      <v-card>
        <v-card-title>
          Filter Date and Time
        </v-card-title>


        <v-card-text class="pt-2">

          <v-col>
              <v-datetime-picker
              v-model="startDate"
              :text-field-props="{appendIcon: 'event', dense:true, flat: true}"
              time-format="HH:mm:ss"
              label="Start Date" />
          </v-col>

          <v-col>
          <v-datetime-picker
              v-model="endDate"
              :text-field-props="{appendIcon: 'event', dense:true, flat: true}"
              timeFormat="HH:mm:ss"
              label="End Date" />
          </v-col>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default darken-1" text @click="onClear()">Clear</v-btn>
          <v-btn
            color="primary"
            text
            @click="onConfirm()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>

import moment from 'moment'
export default {

  data () {
    return {
      dialog: false,
      startDate: '',
      endDate: '',
      SelectedDateTime: '',
    }
  },

  mounted () {
      const {
          startDate,
          endDate,
      } = this.$route.query

      this.startDate = startDate ?? ''
      this.endDate = endDate ?? ''
      this.setSelectedDateTime()
  },

  watch: {
      SelectedDateTime(val, oldVal) {
          if(val === '' || val === null) {
              this.$emit('onSelectDateTime', '', '');
          }
      }
  },

  methods: {
      onClear() {
          this.SelectedDateTime = '';
          this.startDate = '';
          this.endDate = '';
          this.$emit('onSelectDateTime', '', '');
          this.dialog = false;
      },

      setSelectedDateTime() {
          if(this.startDate) {
              this.SelectedDateTime = `${moment(this.startDate).format('YYYY-MM-DD HH:mm')} - `;
          }

          if(this.endDate) {
              this.SelectedDateTime += `${moment(this.endDate).format('YYYY-MM-DD HH:mm')}`;
          }
      },

      onConfirm() {
          let startDate = this.startDate ?? '';
          let endDate = this.endDate ?? '';

          // Validate startDate and endDate
          if (moment(startDate, moment.ISO_8601, true).isValid()) {
              startDate = moment(startDate).format('YYYY-MM-DD HH:mm:ss');
          } else {
              startDate = ''; // Reset if invalid
          }

          if (moment(endDate, moment.ISO_8601, true).isValid()) {
              endDate = moment(endDate).format('YYYY-MM-DD HH:mm:ss');
          } else {
              endDate = ''; // Reset if invalid
          }

          // Only add valid dates to the query
          const queryParams = { ...this.$route.query };
          if (startDate) queryParams.startDate = startDate;
          if (endDate) queryParams.endDate = endDate;

          // Avoid redundant navigation
          if (
              this.$route.query.startDate === queryParams.startDate &&
              this.$route.query.endDate === queryParams.endDate
          ) {
              this.dialog = false;
              return;
          }

          this.$router.push({
              path: this.$route.path,
              query: queryParams,
          }).catch(err => {
              if (err.name !== 'NavigationDuplicated') {
                  console.error(err);
              }
          });


          this.setSelectedDateTime();
          this.$emit('onSelectDateTime', startDate, endDate);
          this.dialog = false;
      }
  },

}
</script>